<ng-container [formGroup]="form">
	<div [class.show-locale]="showLocale || showWritingTools">
		<mat-form-field
			class="no-underline no-hint no-min-width"
			[class.fix-placeholder]="fixPlaceholderStyle"
			[class.dark-color]="darkMode"
			[class.form-control]="darkMode"
			[class.form-field]="darkMode"
			[class.full-width]="fullWidth"
			appearance="fill"
			[floatLabel]="floatLabel"
		>
			<mat-label *ngIf="label">{{ label }}</mat-label>
			<input
				matInput
				[type]="type"
				#textInput
				[name]="controlName"
				[formControlName]="controlName"
				[placeholder]="placeholder"
				[minlength]="minLength"
				[maxlength]="maxLength"
				[matAutocomplete]="auto"
			/>
			<mat-icon *ngIf="prefix" matPrefix>{{ prefix }}</mat-icon>
			<button
				*ngIf="showColorPicker"
				#colorPickerButton
				mat-icon-button
				matSuffix
				type="button"
				class="color-picker-button"
				(click)="toggleColorPicker($event)"
			>
				<span class="color-preview" [style.background-color]="getColorForPicker()"></span>
			</button>
			<mat-icon *ngIf="suffix"
					  class="suffix"
					  [class.suffix-active]="suffixActive"
					  [matTooltip]="suffixTooltip ? suffixTooltip : undefined"
					  matSuffix
					  (click)="suffixClick.emit()">{{ suffix }}</mat-icon>
		</mat-form-field>

		<ng-container *ngIf="showColorPicker && isColorPickerOpen">
			<div #colorPickerPanel class="color-picker-popover" (mousedown)="$event.stopPropagation()">
				<span
					[colorPicker]="getColorForPicker()"
					[cpWidth]="'230px'"
					[cpDialogDisplay]="'inline'"
					[cpToggle]="true"
					[cpCancelButton]="false"
					[cpAddColorButton]="false"
					[cpAlphaChannel]="'disabled'"
					(colorPickerChange)="onColorChange($event)"
				></span>

				<!-- Brand Kit Color Picker -->
				<app-brand-kit-color-picker
					*ngIf="includeBrandKitColors && packageId"
					class="mt-2"
					[packageId]="packageId"
					[currentValue]="getColorForPicker()"
					(colorSelected)="onBrandKitColorSelected($event)"
				></app-brand-kit-color-picker>
			</div>
		</ng-container>

		<mat-autocomplete
			class="tiny-autocomplete"
			#auto="matAutocomplete"
			(optionSelected)="onSuggestionSelected($event)"
		>
			<mat-option *ngFor="let suggestion of suggestions" [value]="suggestion">
				<span [innerHTML]="highlightMatch(suggestion, currentSearchTerm)"></span>
			</mat-option>
		</mat-autocomplete>

		<app-writing-tools
			*ngIf="showWritingTools"
			[value]="form.get(controlName)?.value"
			(valueChanged)="onWritingToolsChange($event)"
		></app-writing-tools>

		<app-set-locale-edit-button
			*ngIf="showLocale"
			[localeData]="localeData"
			(localeChange)="localeChange.emit($event)"
		></app-set-locale-edit-button>
	</div>

	<div *ngIf="hint" class="input-hint">{{ hint }}</div>
</ng-container>
